import React from 'react';
import {useForm} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import ListFiltersForm from 'shared/ui/Modal/ListFiltersForm/ListFiltersForm';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import {getYesNoOptions} from 'shared/lib/filterOptions';

interface ITariffsFiltersForm {
    isArchive?: string,
    isDefault?: string,
    isRecommended?: string,
}

const TariffsFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => {
    const [searchParams] = useSearchParams();

    const {handleSubmit, control} = useForm<ITariffsFiltersForm>({
        defaultValues: {
            isArchive: searchParams.get('is_archive') ?? undefined,
            isDefault: searchParams.get('is_default') ?? undefined,
            isRecommended: searchParams.get('is_recommended') ?? undefined,
        },
    });

    const toFilters = ({isArchive, isDefault, isRecommended}: ITariffsFiltersForm) => ({
        is_archive: isArchive ?? undefined,
        is_default: isDefault ?? undefined,
        is_recommended: isRecommended ?? undefined,
    });

    return (
        <ListFiltersForm handleSubmit={handleSubmit} toFilters={toFilters} onClose={onClose}>
            <FormGroupWithError label={t`Архивный`}>
                <Select
                    control={control}
                    name="isArchive"
                    data={getYesNoOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`По умолчанию`}>
                <Select
                    control={control}
                    name="isDefault"
                    data={getYesNoOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Рекомендуемый`}>
                <Select
                    control={control}
                    name="isRecommended"
                    data={getYesNoOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>
        </ListFiltersForm>
    );
};

export default TariffsFiltersForm;
